import { getUnicoDataByProposalId } from "@/services/unicoData.service";
import { getFormalizationUrl } from "@/utils/formalizationUrl";
import {
  Box,
  Button,
  Flex,
  Input,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import Logo from "../Logo";
import { useSlug } from "@/contexts/selfServiceSlugContext";
import { useWhiteLabelStore } from "@/contexts/whiteLabelContext";

export default function ShareLinkPage() {
  const { selfServiceSlug } = useSlug();

  const location = useLocation();
  const whatsappNumber = selfServiceSlug?.supportPhone;

  const getAssets = useWhiteLabelStore.getState().getAssets;
  const { slug } = getAssets();
  
  const toast = useToast();
  const [unicoDataId, setUnicoDataId] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchUnicoData = async () => {
      try {
        const proposalId = location?.state?.proposal?.id;
        if (proposalId) {
          const unicoData = await getUnicoDataByProposalId(proposalId);
          setUnicoDataId(unicoData?.id || "");
        } else {
          toast({
            title: "Erro",
            description: "ID da proposta não encontrado.",
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "top",
          });
        }
      } catch (error) {
        console.error("Erro ao buscar UnicoData:", error);
        toast({
          title: "Erro",
          description: "Não foi possível buscar os dados da Unico.",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top",
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchUnicoData();
  }, [location, toast]);

  const linkToCopy = getFormalizationUrl(unicoDataId, slug);

  const handleSupport = () => {
    let phoneNumber = "+55" + whatsappNumber?.replace(/\D/g, "");

    const message =
      "Olá, estou tentando antecipar meu saque aniversário e tenho uma dúvida!";
    const whatsappURL = `https://wa.me/${phoneNumber}/?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, "_blank");
  };

  if (isLoading) {
    return (
      <Flex justify="center" align="center" w="100%" minH="100vh">
        <Text>Carregando...</Text>
      </Flex>
    );
  }

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      w="100%"
      bg="gray.100"
      minH="100vh"
      p={{ base: 3, md: 6 }}
    >
      <Flex justify="flex-end" align="center" position="absolute" top={4}>
        <Logo
          w={{ base: "50px", md: "70px" }}
          variant="primary"
          alt="Logo"
          right={{ base: "47%", md: "50%" }}
        />
      </Flex>

      <Button
        position={"absolute"}
        top={6}
        right={6}
        onClick={handleSupport}
        size="sm"
        variant="outline"
        leftIcon={<FaWhatsapp size={16} />}
        color="primary"
        bg="white"
        _hover={{ bg: "white", color: "primary" }}
      >
        Suporte
      </Button>
      <VStack
        spacing={{ base: 5, md: 8 }}
        p={{ base: 5, md: 10 }}
        boxShadow="2xl"
        borderRadius="lg"
        bg="white"
        w={{ base: "95%", md: "50%", lg: "40%" }}
      >
        <Text
          fontSize={{ base: "2xl", md: "2xl" }}
          fontWeight="bold"
          color="gray.700"
          textAlign="center"
          fontFamily="Lexend Deca"
        >
          Etapa Final.
        </Text>

        <Text
          fontSize={{ base: "lg", md: "lg" }}
          color="gray.600"
          textAlign="center"
          fontFamily="Lexend Deca"
        >
          Para o dinheiro cair em sua conta por favor, faça a assinatura digital
          de seu contrato.
        </Text>
        <Text
          fontSize={{ base: "lg", md: "lg" }}
          color="gray.600"
          textAlign="center"
          fontFamily="Lexend Deca"
        >
          Clique no link abaixo para prosseguir para assinatura:
        </Text>

        <Box w="100%" position="relative">
          <Input
            value={linkToCopy}
            isReadOnly
            size={{ base: "md", md: "lg" }}
            borderColor="gray.300"
            _focus={{
              borderColor: "green.500",
              boxShadow: "0 0 0 1px green.500",
            }}
            bg="gray.50"
            borderRadius="md"
            p={{ base: 3, md: 5 }}
            pr={{ base: "90px", md: "100px" }}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          />
          <Button
            as="a"
            href={linkToCopy}
            target="_blank"
            rel="noopener noreferrer"
            position="absolute"
            right={2}
            top="50%"
            transform="translateY(-50%)"
            fontFamily="Lexend Deca"
            colorScheme="green"
            size={{ base: "sm", md: "sm" }}
            minW={{ base: "80px", md: "90px" }}
          >
            Abrir
          </Button>
        </Box>
      </VStack>
    </Flex>
  );
}
